import { useEffect, useState } from 'react'
import { useGetQuery } from 'hooks'
import { Box } from '../box'
import { Month, Day, Name, Container } from './styles'

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]

const pad = (n) => String(n).padStart(2, '0')

const localDateString = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

export const Holiday = () => {
  const [date] = useState(() => new Date())
  const [index, setIndex] = useState(0)

  const { data, reFetch } = useGetQuery({
    url: `/events?event_type=holiday&on=${localDateString(date)}&limit=200`
  })

  const holidays = data?.events?.rows || []

  // Rotate to a random holiday every 20 seconds
  useEffect(() => {
    if (holidays.length <= 1) return
    const id = setInterval(
      () => setIndex(Math.floor(Math.random() * holidays.length)),
      20000
    )
    return () => clearInterval(id)
  }, [holidays.length])

  // Refresh once an hour so the panel rolls over to the next day
  useEffect(() => {
    const id = setInterval(() => reFetch(true), 60 * 60 * 1000)
    return () => clearInterval(id)
  }, [])

  if (data === undefined) return <Box />

  const holiday = holidays[index] || holidays[0]
  if (!holiday) {
    return (
      <Box>
        <Name>No holidays today</Name>
      </Box>
    )
  }

  return (
    <Box>
      <Container>
        <Month>{MONTHS[date.getMonth()]}.</Month>
        <Day>{date.getDate()}</Day>
        <Name>{holiday.name}</Name>
      </Container>
    </Box>
  )
}
